import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
    selector: 'platform-progress-tracker',
    standalone: true,
    imports: [CommonModule, ProgressBarModule],
    template: `
        @if (disableRoute) {
            <div class="disabled-overlay"></div>
        }
        <div class="progress-tracker-container">
            <img
                [src]="statusImage || defaultImage"
                alt="Progress Status"
                class="status-image"
                (error)="onImageError()"
            />

            <div class="progress-container">
                <p-progressBar
                    [value]="progressValue"
                    [style]="{ width: '130px', height: '0.5rem' }"
                    color="var(--alpha-success-color,#099250)"
                >
                </p-progressBar>

                <div class="progress-text" [ngStyle]="{ color: appliedStyle.textColor }">{{ current }}/{{ total }}</div>
            </div>
            <div class="progress-header" [ngStyle]="{ color: appliedStyle.headerColor }">
                {{ header }}
            </div>
            <div class="progress-subtitle" [ngStyle]="{ color: appliedStyle.subTitleColor }">
                {{ subtitle }}
            </div>
        </div>
    `,
    styles: [
        `
            .progress-tracker-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
                text-align: center;
                font-family: 'IBM Plex Sans', sans-serif;
            }
            .progress-container {
                display: flex;
                align-items: center;
                gap: 0.5rem;
            }

            .status-image {
                width: 340px;
                height: auto;
                margin-bottom: 1.5rem;
            }

            .custom-progress-bar {
                width: 60%;
                height: 0.5rem;
            }

            .progress-text {
                font-size: 0.75rem;
                font-weight: 500;
            }

            .progress-header {
                font-size: 1.75rem;
                font-weight: 600;
                margin: 0.5rem 0;
            }

            .progress-subtitle {
                font-size: 1rem;
                font-weight: 400;
            }

            .disabled-overlay {
                position: absolute;
                top: 0;
                left: 0;
                cursor: not-allowed;
                background-color: transparent;
                width: 100%;
                height: 100%;
            }
        `,
    ],
})
export class ProgressTrackerComponent {
    @Input() header: string = 'default-reassign-bulkReassignmentInProgress';
    @Input() subtitle: string = 'default-reassign-bulkReassignmentInProgressSubtitle';
    @Input() total: number = 40;
    @Input() current: number = 21;
    @Input() statusImage: string = '';
    @Input() appliedStyle: StyleObject = {
        subTitleColor: 'black',
        headerColor: 'black',
        textColor: 'black',
    };
    @Input() disableRoute: boolean = false;

    // Placeholder image from Unsplash that should be CORS-safe
    defaultImage: string = 'https://source.unsplash.com/featured/?workflow';

    get progressValue(): number {
        const value = (this.current / this.total) * 100;
        return value;
    }

    onImageError() {
        this.statusImage = this.defaultImage;
    }
}

interface StyleObject {
    subTitleColor: string;
    headerColor: string;
    textColor: string;
}
